import { useEffect } from 'react';
import axiosWrapper from '../../services/axiosWrapper';

const GoogleSigninButton = ({ handleLoginResponse }) => {
  const inIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
  };

  const handleGoogleLoginCallback = async (response) => {
    const loginParams = {
      type: 'google',
      code: response.credential,
    };

    try {
      const response = await axiosWrapper.post(`${process.env.REACT_APP_CUBE_BACKEND}/accounts/socialLogin`, loginParams);
      if (handleLoginResponse) {
        handleLoginResponse(response);
      }
      else if (inIframe()) {
        window.parent.postMessage(JSON.stringify({
          type: 'googleLoginCallback',
          data: response,
        }), '*');
      }
    }
    catch (e) {}
  };

  const loadScripts = () => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = false;
    script.onload = () => {
      google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        callback: handleGoogleLoginCallback,
      });
      google.accounts.id.renderButton(
        document.getElementById('googleLoginButton'),
        { theme: 'outline', size: 'large' }, // customization attributes
      );
      // TODO: Not possible at this point as button is rendered from inside iframe
      // google.accounts.id.prompt(); // also display the One Tap dialog
    };
    document.body.appendChild(script);
  };

  useEffect(() => {
    setInterval(() => {
      // TODO; patch to remove the freshchat icon from bottom
      if (document.getElementById('fc_frame')) {
        document.getElementById('fc_frame').style.display = 'none';
      }
    }, 1000);
    loadScripts();
  }, []);

  return (
    <div className="overflow-hidden" id="googleLoginButton" />
  );
};

export default GoogleSigninButton;
